import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 12px;
  padding: 16px 20px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 480px;
  overflow-y: auto;

  .menu-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      text-transform: capitalize;
      font-size: 1rem;
      font-weight: bold;
      color: #333;
    }

    .icon {
      color: #4f46e5;
    }
  }

  .content {
    display: flex;
    align-items: baseline;
    gap: 8px;

    .total {
      font-size: 2rem;
      font-weight: bold;
      color: #4f46e5;
    }

    .label {
      font-size: 0.85rem;
      color: #6b7280;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    background: #f7f8fc;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    transition: background-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      background-color: #eef2ff;
      box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);
    }

    .img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: #e2e8f0;
      overflow: hidden;
      flex: 0 0 auto;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      svg {
        color: #94a3b8;

        &.hidden {
          display: none;
        }
      }
    }

    .description {
      font-weight: 600;
      font-size: 0.9rem;
      color: #374151;
      flex: 1 1 40%;
    }

    .terminal,
    .qty {
      font-size: 0.82rem;
      color: #6b7280;
      flex: 0 0 auto;
    }

    .total-value {
      font-weight: 700;
      font-size: 0.9rem;
      color: #111827;
      flex: 0 0 auto;
      text-align: right;
    }

    .view-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: none;
      border: none;
      color: #4f46e5;
      padding: 4px;
      border-radius: 6px;
      cursor: pointer;
      flex: 0 0 auto;
      transition: background-color 0.15s ease;

      &:hover {
        background-color: rgba(79, 70, 229, 0.12);
      }
    }
  }

  .not-data {
    font-size: 0.85rem;
    font-weight: 600;
    color: #9ca3af;
    text-align: center;
    padding: 1.5rem 0;
  }

  .footer-actions {
    display: flex;
    justify-content: flex-end;
    padding-top: 4px;
  }
`;

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;

  .terminal {
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
  }

  .terminal-label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #9ca3af;
    margin-right: 6px;
  }
`;

export const DetailTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead th {
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #9ca3af;
    text-align: left;
    padding: 4px 6px;
  }

  tbody td {
    font-size: 0.88rem;
    font-weight: 600;
    color: #111827;
    padding: 4px 6px;
  }

  th:not(:first-child),
  td:not(:first-child) {
    text-align: center;
  }

  th:last-child,
  td:last-child {
    text-align: right;
  }
`;

export const DetailFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #e5e7eb;

  .footer-item {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }

  .footer-label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #9ca3af;
  }

  .footer-value {
    font-size: 0.85rem;
    font-weight: 600;
    color: #111827;
  }

  .total-value {
    font-size: 0.95rem;
    font-weight: 700;
    color: #111827;
  }
`;
